'use client';

import type { MenuData, MenuVariant } from '@zoomit/web-kit';
import { isMobile, MenuParser, MenuProvider } from '@zoomit/web-kit';

import StickySearch from '../StickySearch';
import StickySearchScrollTrigger from '../StickySearchScrollTrigger';
import { SearchInstanceLite } from './SearchInstanceLite';

type Props = {
  data?: MenuData | null;
  variant?: MenuVariant;
  showStickySearch?: boolean;
  triggerStickyOnScroll?: boolean;
};

export const Menu = (props: Props) => {
  const { data, variant, triggerStickyOnScroll, showStickySearch } = props;

  const showSticky = isMobile && showStickySearch;
  const triggerSticky = showSticky && triggerStickyOnScroll;

  if (!data) return null;

  return (
    <MenuProvider menuItems={data?.items || []}>
      <MenuParser
        searchInstanceRenderer={(props) => <SearchInstanceLite {...props} />}
        menuData={data}
        variant={variant}
      />
      {triggerSticky ? <StickySearchScrollTrigger /> : showSticky ? <StickySearch /> : null}
    </MenuProvider>
  );
};
